export const UPDATE_MODEL_EVENT = 'update:modelValue'
export const CHANGE_EVENT = 'change'
export const CHECKED_CHANGE_EVENT = 'checked-change'
export const INPUT_EVENT = 'input'
